import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import File from '../../../../../core/components/Uploaders/File';
const FilesContainer = styled.div `
  & > * {
    margin-bottom: 12px;
  }
`;
const FileContentList = ({ items, onRemove }) => (React.createElement(FilesContainer, null, items.map((post) => {
    var _a;
    return (React.createElement(File, { key: post.postId, fileId: (_a = post === null || post === void 0 ? void 0 : post.data) === null || _a === void 0 ? void 0 : _a.fileId, onRemove: () => onRemove(post.postId) }));
})));
FileContentList.propTypes = {
    items: PropTypes.array,
    onRemove: PropTypes.func,
};
FileContentList.defaultProps = {
    items: [],
    onRemove: () => { },
};
export default FileContentList;
//# sourceMappingURL=file.js.map